import React from "react";

const CarouselImage = ({ image, alt }) => {

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${image})`,
        backgroundOrigin: "border-box",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
  );
};

export default CarouselImage;
